import React, { Component } from 'react'
import { Card } from 'react-bootstrap';
import RecepcionStatusBadge from './RecepcionStatusBadge';

class RecepcionValidacionInfo extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Card className="mb-2">
        <Card.Body>
          <strong className="text-black card-label-info">Valid: </strong>
          <RecepcionStatusBadge valid={ data.valid } />
          <br/>
          <br/>

          <strong className="text-black card-label-info">Validación: </strong>
          { data.validation }
          <br/>

          <strong className="text-black card-label-info">Descripción: </strong>
          { data.description }
          <br/>

          { data.validation === 'cfdi_status' && (
            <>
              <strong className="text-black card-label-info">Código: </strong>
              { data.meta.CodigoEstatus }
              <br/>

              <strong className="text-black card-label-info">Estado: </strong>
              { data.meta.Estado }
              <br/>

              <strong className="text-black card-label-info">Es Cancelable: </strong>
              { data.meta.EsCancelable }
              <br/>

              <strong className="text-black card-label-info">Cancelación: </strong>
              { data.meta.EstatusCancelacion }
              <br/>

              <strong className="text-black card-label-info">Validación EFOS: </strong>
              { data.meta.ValidacionEFOS }
              <br/>
            </>
          )}
        </Card.Body>
      </Card>
    )
  }
}

export default RecepcionValidacionInfo;